module.exports = __webpack_public_path__ + "static/architecture-ecfb3bedcce8afe0a6de76968e1915a8.png";